var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptLogo01Darkmode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 220 51",
    style: {
      enableBackground: "new 0 0 220 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    transform: "translate(-6222.659 885.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    transform: "translate(6284.873 -875.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    fill: "#E7E9EE",
    d: "M13.54,0.58C20.51,0.58,24,4.6,24,9.54c0.08,3.89-2.54,7.31-6.32,8.23l6.57,11.27h-7.83 L10.5,18.3H8.83v10.74H1.9V0.58L13.54,0.58z M13.13,6.34h-4.3v7.06h4.3c2.59,0,3.81-1.34,3.81-3.57 C16.95,7.71,15.73,6.34,13.13,6.34L13.13,6.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    fill: "#E7E9EE",
    d: "M36.78,29.37c-6.65,0-11.43-4.46-11.43-11.64s4.7-11.64,11.43-11.64 c6.61,0,11.27,4.38,11.27,11.27c0,0.68-0.04,1.35-0.12,2.03H32.24c0.24,2.96,2.07,4.34,4.3,4.34c1.54,0.1,2.98-0.78,3.61-2.19 h7.38C46.43,25.96,42.42,29.37,36.78,29.37z M32.28,15.54h8.68c0-2.47-1.95-3.89-4.26-3.89C34.43,11.57,32.49,13.28,32.28,15.54 L32.28,15.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    fill: "#E7E9EE",
    d: "M61.69,6.09c5.68,0,9.69,3.12,10.86,8.51h-7.38c-0.45-1.6-1.95-2.67-3.61-2.59 c-2.47,0-4.18,1.95-4.18,5.72s1.7,5.72,4.18,5.72c1.67,0.1,3.17-0.98,3.61-2.59h7.38c-1.17,5.23-5.19,8.52-10.86,8.52 c-6.65,0-11.36-4.46-11.36-11.64C50.34,10.59,55.04,6.09,61.69,6.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    fill: "#E7E9EE",
    d: "M82.38,29.04h-6.93V6.42h6.93v3.77c1.52-2.47,4.2-3.98,7.09-4.01v7.34h-1.91 c-3.28,0-5.19,1.13-5.19,5.03L82.38,29.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    fill: "#E7E9EE",
    d: "M109.23,6.42h7.5l-14.19,33.36h-7.46l5.19-11.52l-9.2-21.85h7.75l5.23,14.15L109.23,6.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    fill: "#E7E9EE",
    d: "M132.35,6.09c5.55,0,9.97,4.46,9.97,11.6s-4.42,11.68-9.97,11.68 c-2.77,0.1-5.39-1.21-6.97-3.49v13.94h-6.93V6.41h6.93v3.21C126.92,7.31,129.57,5.97,132.35,6.09z M130.28,12.13 c-2.6,0-4.95,1.99-4.95,5.6s2.35,5.6,4.95,5.6c2.64,0,4.99-2.03,4.99-5.64S132.92,12.13,130.28,12.13L130.28,12.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    fill: "#E7E9EE",
    d: "M146.27,12.17h-2.76V6.42h2.76V0.9h6.93v5.51h4.54v5.76h-4.54v9.08c0,1.34,0.57,1.9,2.11,1.9 h2.47v5.88h-3.53c-4.7,0-7.99-1.99-7.99-7.87V12.17z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    fill: "#34DAE2",
    d: "M6249.11-863.1l4.63-3.87l2.49,4.53l-5.47,1.92l5.48,1.87l-2.67,4.72l-4.45-3.92l1.11,5.79 h-5.21l1.07-5.79l-4.41,3.96l-2.76-4.81l5.47-1.91l-5.43-1.78l2.54-4.58l4.63,3.87l-1.16-5.87h5.3L6249.11-863.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    fill: "#34DAE2",
    d: "M6222.66-885.43v49.82h49.82v-49.82H6222.66z M6265.55-842.54h-35.96v-35.96h35.96V-842.54z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptLogo01Darkmode);
export default __webpack_public_path__ + "static/media/recrypt_logo_01_darkmode.05180076.svg";
export { ForwardRef as ReactComponent };